/* Start -   Polyfill for IE  - Closest fn support*/
if (!Element.prototype.matches) {
  Element.prototype.matches =
    Element.prototype.msMatchesSelector ||
    Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
  Element.prototype.closest = function(sEvent) {
    /* eslint-disable consistent-this */
    let currentElement = this;

    /* eslint-enable consistent-this */
    /* eslint-disable better/no-whiles */
    do {
      if (Element.prototype.matches.call(currentElement, sEvent)) {
        return currentElement;
      }

      currentElement = currentElement.parentElement || currentElement.parentNode;
    } while (currentElement !== null && currentElement.nodeType === 1);

    /* eslint-enable better/no-whiles*/
    return null;
  };
}
/* End -   Polyfill for IE  - Closest fn support*/
